<template>
  <CCard class="summary-card">
    <CCardHeader>
      <strong>Payslip summary</strong>
    </CCardHeader>
    <CCardBody>
      <div class="d-flex justify-content-between mb-2">
        <span class="text-muted">Gross pay</span>
        <span>{{ money(grossIncome) }}</span>
      </div>
      <div class="d-flex justify-content-between mb-2">
        <span class="text-muted">Deductions</span>
        <span>{{ money(totalDeductions) }}</span>
      </div>
      <hr class="my-2" />
      <div class="d-flex justify-content-between align-items-baseline mb-3">
        <strong>Net pay</strong>
        <span class="h5 mb-0 font-weight-bold">{{ money(netPay) }}</span>
      </div>

      <h3 class="h6 font-weight-bold mb-2">Statutory contributions</h3>
      <div class="table-responsive">
        <table class="table table-sm mb-0 small">
          <thead>
            <tr>
              <th></th>
              <th class="text-right">Employee</th>
              <th class="text-right">Employer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>EPF <HrGlossaryTip term="EPF" /></td>
              <td class="text-right">{{ money(epfEmployee) }}</td>
              <td class="text-right">{{ money(epfEmployer) }}</td>
            </tr>
            <tr>
              <td>SOCSO <HrGlossaryTip term="SOCSO" /></td>
              <td class="text-right">{{ money(socsoEmployee) }}</td>
              <td class="text-right">{{ money(socsoEmployer) }}</td>
            </tr>
            <tr>
              <td>EIS <HrGlossaryTip term="EIS" /></td>
              <td class="text-right">{{ money(eisEmployee) }}</td>
              <td class="text-right">{{ money(eisEmployer) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <th class="text-right" colspan="2">{{ money(totalStatutory) }}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <hr class="my-3" />
      <div class="d-flex justify-content-between">
        <span class="text-muted">Total cost to you</span>
        <strong>{{ money(totalEmploymentCost) }}</strong>
      </div>
      <small class="text-muted">Gross pay plus employer contributions</small>
    </CCardBody>
  </CCard>
</template>

<script>
import { formatMyr } from "@/utils/money";
import HrGlossaryTip from "./HrGlossaryTip";

export default {
  name: "PayslipSummaryComponent",
  components: { HrGlossaryTip },
  props: {
    grossIncome: {
      type: Number,
      default: 0,
    },
    totalDeductions: {
      type: Number,
      default: 0,
    },
    netPay: {
      type: Number,
      default: 0,
    },
    totalEmployerContributions: {
      type: Number,
      default: 0,
    },
    statutorySummary: {
      type: Array,
      default: () => [],
    },
    // Kept for compatibility; amounts are always shown in RM.
    currency: {
      type: String,
      default: "MYR",
    },
  },
  computed: {
    epfEmployee() {
      return this.amountFor("EPF", "employeeAmount");
    },
    epfEmployer() {
      return this.amountFor("EPF", "employerAmount");
    },
    socsoEmployee() {
      return this.amountFor("SOCSO", "employeeAmount");
    },
    socsoEmployer() {
      return this.amountFor("SOCSO", "employerAmount");
    },
    eisEmployee() {
      return this.amountFor("EIS", "employeeAmount");
    },
    eisEmployer() {
      return this.amountFor("EIS", "employerAmount");
    },
    totalStatutory() {
      return this.statutorySummary.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
    },
    totalEmploymentCost() {
      return this.grossIncome + this.totalEmployerContributions;
    },
  },
  methods: {
    amountFor(type, field) {
      const row = this.statutorySummary.find((s) => s.type === type);
      return row ? row[field] : 0;
    },
    money(amount) {
      return `RM ${formatMyr(amount)}`;
    },
  },
};
</script>

<style scoped>
@media (min-width: 992px) {
  .summary-card {
    position: sticky;
    top: 20px;
  }
}
</style>
